import styled from 'styled-components';
import React from 'react'
import { Button, Form, Icon } from 'semantic-ui-react';
import { FormFields } from '~/components/FormFields';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TimeInput } from 'semantic-ui-calendar-react';

interface Props {
  index: number
  remove: (index: number) => void
}

const DayContainer = styled.div`
  border: 1px solid #e0e0e0;
  padding: 30px 15px 15px;
  margin-bottom: 15px;
  border-radius: 4px;
  background-color: #f9f9f9;
  position: relative;
`;

const RemoveButton = styled(Button)`
  position: absolute !important;
  top: 10px;
  right: 10px;
`;

const Period: React.FC<Props> = ({ index, remove }) => {
  const { t } = useTranslation()
  const { control, setValue, clearErrors } = useFormContext()

  const watchTimeFrom = useWatch({ control, name: `days[${index}].timeFrom` })
  const watchTimeTo = useWatch({ control, name: `days[${index}].timeTo` })

  const dayOptions = [
    { value: 1, text: t('Monday') },
    { value: 2, text: t('Tuesday') },
    { value: 3, text: t('Wednesday') },
    { value: 4, text: t('Thursday') },
    { value: 5, text: t('Friday') },
    { value: 6, text: t('Saturday') },
    { value: 7, text: t('Sunday') }
  ];

  return <DayContainer>
    <RemoveButton
      type='button'
      icon
      basic
      size='mini'
      color='red'
      onClick={() => remove(index)}
    >
      <Icon name='trash' />
    </RemoveButton>

    <Form.Group widths='equal'>
      <FormFields.Select
        control={control}
        name={`days[${index}].day`}
        options={dayOptions}
        label={t('Day')}
        placeholder={t('Select day')}
        rules={{
          required: t('Please select day')
        }}
      />
      <FormFields.Input
        control={control}
        name={`days[${index}].maxTemp`}
        label={t('Max temperature')}
        placeholder={t('Max temperature')}
        typeInput={'controled'}
        allowDecimals
        decimalScale={1}
        rules={{
          required: t('Please enter max temperature')
        }}
      />
    </Form.Group>

    <Form.Group widths='equal'>
      <Controller
        control={control}
        name={`days[${index}].timeFrom` as string}
        rules={{
          required: t('Please select time')
        }}
        render={({ fieldState }) => (
          <Form.Field error={Boolean(fieldState.error)}>
            <label>{t('Start time')}</label>
            <TimeInput
              name='time'
              placeholder='Select time'
              value={watchTimeFrom}
              iconPosition='left'
              onChange={(_, { value }) => {
                clearErrors(`days[${index}].timeFrom`)
                setValue(`days[${index}].timeFrom`, value === '' ? null : value)
              }}
              popupPosition='bottom left'
              closable
            />
          </Form.Field>
        )}
      />
      <Controller
        control={control}
        name={`days[${index}].timeTo` as string}
        rules={{
          required: t('Please select time')
        }}
        render={() => (
          <Form.Field>
            <label>{t('End time')}</label>
            <TimeInput
              name='time'
              placeholder='Select time'
              value={watchTimeTo}

              iconPosition='left'
              onChange={(_, { value }) => {
                clearErrors(`days[${index}].timeTo`)
                setValue(`days[${index}].timeTo`, value === '' ? null : value)
              }}
              popupPosition='bottom left'
              closable
            />
          </Form.Field>
        )}
      />
    </Form.Group>
  </DayContainer>
}
export default Period